import React, { useCallback, useEffect, useRef, useState } from 'react';
import jsQR from 'jsqr';
import { api } from '../lib/api';

const LS = 'tv_staff_token';
const lsGet = () => { try { return localStorage.getItem(LS) || ''; } catch (e) { return ''; } };
const lsSet = (v) => { try { if (v) localStorage.setItem(LS, v); else localStorage.removeItem(LS); } catch (e) { /* ignore */ } };
const errOf = (e, fb) => (e && e.response && e.response.data && e.response.data.detail) ? String(e.response.data.detail) : (fb || 'Terjadi kesalahan, coba lagi.');
const H = () => ({ headers: { 'X-Staff': lsGet() } });
const isAuthErr = (e) => !!(e && e.response && e.response.status === 401);
const when = (v) => {
  if (!v) return '-';
  const s = String(v); const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  return isNaN(d) ? '-' : d.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
};

const CSS = `
@font-face { font-family: 'Akira Expanded'; src: url('/fonts/akira-expanded.otf') format('opentype'); font-display: swap; }
.tvr { min-height: 100vh; background-color: #ECEAE4; background-image: repeating-linear-gradient(0deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px), repeating-linear-gradient(90deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px); color: #111; font-family: 'DM Sans', system-ui, sans-serif; }
.tvr-wrap { max-width: 620px; margin: 0 auto; padding: 18px 16px 40px; }
.tvr-h { font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; text-transform: uppercase; letter-spacing: -0.01em; line-height: 1.02; }
.tvr-lbl { display: block; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; margin-bottom: 6px; }
.tvr-card { background: #fff; border: 2px solid #111; box-shadow: 6px 6px 0 #111; padding: 18px; }
.tvr-in { width: 100%; background: #fff; border: 1.5px solid #111; border-radius: 0; padding: 12px; font-size: 16px; font-family: inherit; color: #111; outline: none; box-sizing: border-box; }
.tvr-in:focus { box-shadow: 3px 3px 0 #111; }
.tvr-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; width: 100%; background: #CAFF00; color: #111; border: 2px solid #111; box-shadow: 5px 5px 0 #111; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; font-size: 14px; letter-spacing: .04em; text-transform: uppercase; padding: 15px 18px; cursor: pointer; transition: transform .12s, box-shadow .12s; }
.tvr-btn:active { transform: translate(2px,2px); box-shadow: 2px 2px 0 #111; }
.tvr-btn:disabled { opacity: .45; cursor: not-allowed; }
.tvr-btn.ghost { background: #fff; font-size: 11px; padding: 10px 12px; box-shadow: 3px 3px 0 #111; width: auto; }
.tvr-btn.big { font-size: 20px; padding: 22px 18px; }
.tvr-note { border: 2px solid #111; background: #FFF6CC; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvr-ok { border: 2px solid #111; background: #DDFBC8; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvr-bad { border: 2px solid #111; background: #FFD9D2; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvr-chip { display: inline-flex; align-items: center; gap: 6px; border: 1.5px solid #111; background: #fff; padding: 5px 9px; font-size: 12px; font-weight: 700; }
.tvr-chip.out { opacity: .45; text-decoration: line-through; }
.tvr-cam { position: relative; border: 2px solid #111; background: #000; aspect-ratio: 1; overflow: hidden; }
.tvr-cam video { width: 100%; height: 100%; object-fit: cover; }
.tvr-cam .fr { position: absolute; inset: 14%; border: 3px solid #CAFF00; box-shadow: 0 0 0 999px rgba(0,0,0,.35); }
.tvr-reel { position: relative; height: 96px; border: 3px solid #111; background: #111; color: #CAFF00; overflow: hidden; display: grid; place-items: center; box-shadow: 6px 6px 0 #111; }
.tvr-reel .it { font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: clamp(18px, 6vw, 28px); text-transform: uppercase; text-align: center; padding: 0 12px; line-height: 1.05; }
.tvr-reel .it.spin { animation: tvrTick .09s linear; }
.tvr-reel::before, .tvr-reel::after { content: ''; position: absolute; left: 0; right: 0; height: 22px; pointer-events: none; }
.tvr-reel::before { top: 0; background: linear-gradient(#111, transparent); }
.tvr-reel::after { bottom: 0; background: linear-gradient(transparent, #111); }
.tvr-win::before, .tvr-win::after { display: none; }
.tvr-win { background: #CAFF00; animation: tvrPop .5s cubic-bezier(.2,1.5,.4,1); }
.tvr-conf { position: fixed; inset: 0; pointer-events: none; overflow: hidden; z-index: 60; }
.tvr-conf i { position: absolute; top: -20px; width: 10px; height: 16px; animation: tvrFall 1.8s ease-in forwards; }
@keyframes tvrTick { from { transform: translateY(-40%); opacity: .3; } to { transform: none; opacity: 1; } }
@keyframes tvrPop { from { transform: scale(.7) rotate(-4deg); opacity: 0; } to { transform: none; opacity: 1; } }
@keyframes tvrFall { to { transform: translateY(110vh) rotate(540deg); opacity: .9; } }
`;

function Scanner({ onCode, onClose }) {
  const vref = useRef(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    let stream = null; let stop = false; let det = null; let cv = null; let cx = null;
    (async () => {
      try {
        if ('BarcodeDetector' in window) { try { det = new window.BarcodeDetector({ formats: ['qr_code'] }); } catch (e) { det = null; } }
        stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false });
        if (stop) return;
        const v = vref.current; v.srcObject = stream; v.setAttribute('playsinline', ''); await v.play();
        cv = document.createElement('canvas'); cx = cv.getContext('2d', { willReadFrequently: true });
        const tick = async () => {
          if (stop) return;
          try {
            if (det) {
              const r = await det.detect(v);
              if (r && r[0] && r[0].rawValue) { stop = true; onCode(r[0].rawValue); return; }
            } else if (v.videoWidth) {
              const w = Math.min(640, v.videoWidth); const h = Math.round(w * (v.videoHeight / v.videoWidth));
              cv.width = w; cv.height = h; cx.drawImage(v, 0, 0, w, h);
              const r = jsQR(cx.getImageData(0, 0, w, h).data, w, h, { inversionAttempts: 'dontInvert' });
              if (r && r.data) { stop = true; onCode(r.data); return; }
            }
          } catch (e) { /* frame belum siap */ }
          setTimeout(tick, 180);
        };
        tick();
      } catch (e) { setErr('denied'); }
    })();
    return () => { stop = true; if (stream) stream.getTracks().forEach((t) => t.stop()); };
  }, [onCode]);
  return (
    <div className="tvr-card" style={{ padding: 12 }} data-testid="redeem-scanner">
      {err ? (
        <div className="tvr-note">Kamera tidak bisa dibuka. Izinkan akses kamera di browser, atau ketik kode TV-XXXXXX di bawah.</div>
      ) : (
        <div className="tvr-cam"><video ref={vref} playsInline muted /><div className="fr" /></div>
      )}
      <button type="button" className="tvr-btn ghost" style={{ marginTop: 12, width: '100%' }} onClick={onClose}>Tutup kamera</button>
    </div>
  );
}

function Confetti() {
  const cols = ['#CAFF00', '#FF8AD8', '#FFC21A', '#111111', '#6F7CF2'];
  return (
    <div className="tvr-conf" aria-hidden="true">
      {Array.from({ length: 46 }).map((_, i) => (
        <i key={i} style={{ left: `${(i * 37) % 100}%`, background: cols[i % cols.length], animationDelay: `${(i % 9) * 0.07}s`, transform: `rotate(${i * 23}deg)` }} />
      ))}
    </div>
  );
}

export default function RedeemPage() {
  const [token, setToken] = useState(lsGet());
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [required, setRequired] = useState(6);
  const [scan, setScan] = useState(false);
  const [manual, setManual] = useState('');
  const [v, setV] = useState(null);
  const [checked, setChecked] = useState(false);
  const [reel, setReel] = useState(null);
  const [win, setWin] = useState(null);
  const [pending, setPending] = useState(() => { try { return new URLSearchParams(window.location.search).get('r') || ''; } catch (e) { return ''; } });
  const timers = useRef([]);

  useEffect(() => {
    document.title = 'Redeem Hadiah | Memories Passport';
    if (!document.getElementById('tvp-dmsans')) {
      const l = document.createElement('link'); l.id = 'tvp-dmsans'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(l);
    }
    if (pending) { try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* ignore */ } }
    return () => timers.current.forEach(clearTimeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const logout = useCallback(() => { lsSet(''); setToken(''); setV(null); setWin(null); setReel(null); }, []);

  const auth = async (e) => {
    e.preventDefault(); setBusy('auth'); setMsg(null);
    try {
      const { data } = await api.post('/passport/staff/auth', { pin });
      lsSet(data.token); setToken(data.token); setRewards(data.rewards || []); setRequired(data.required || 6); setPin('');
    } catch (e2) { setMsg({ ok: false, t: errOf(e2) }); } finally { setBusy(''); }
  };

  const lookup = useCallback(async (code) => {
    const c = String(code || '').trim();
    if (!c) return;
    setScan(false); setBusy('look'); setMsg(null); setV(null); setWin(null); setReel(null); setChecked(false);
    try {
      const { data } = await api.post('/passport/staff/lookup', { code: c }, H());
      setV(data.passport); setRewards(data.rewards || []); setRequired(data.required || 6); setManual('');
    } catch (e2) {
      if (isAuthErr(e2)) { logout(); setMsg({ ok: false, t: errOf(e2) }); } else setMsg({ ok: false, t: errOf(e2) });
    } finally { setBusy(''); }
  }, [logout]);

  useEffect(() => { if (token && pending) { const c = pending; setPending(''); lookup(c); } }, [token, pending, lookup]);

  const spin = async () => {
    if (!v) return;
    setBusy('spin'); setMsg(null); setWin(null);
    let res;
    try {
      const { data } = await api.post('/passport/staff/redeem', { visitor_id: v.id }, H());
      res = data;
    } catch (e2) {
      setBusy('');
      if (isAuthErr(e2)) logout();
      setMsg({ ok: false, t: errOf(e2) });
      if (e2 && e2.response && e2.response.status === 409) lookup(v.code);
      return;
    }
    const names = (res.pool && res.pool.length ? res.pool : rewards).map((r) => r.name);
    const seq = [];
    let t = 0; let d = 55;
    for (let i = 0; i < 22; i += 1) { t += d; d = Math.min(340, d * 1.12); seq.push(t); }
    timers.current.forEach(clearTimeout); timers.current = [];
    seq.forEach((at, i) => {
      timers.current.push(setTimeout(() => setReel({ name: i === seq.length - 1 ? res.reward.name : names[(i * 7 + 3) % names.length], k: i }), at));
    });
    timers.current.push(setTimeout(() => {
      setWin(res.reward); setV(res.passport); setRewards(res.rewards || rewards); setBusy('');
    }, t + 450));
  };

  const next = () => { setV(null); setWin(null); setReel(null); setMsg(null); setScan(true); };

  const head = (
    <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 10, marginBottom: 16 }}>
      <div>
        <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 11, letterSpacing: '.08em' }}>MEMORIES PASSPORT | INFO BOOTH</div>
        <h1 className="tvr-h" style={{ fontSize: 'clamp(26px, 8vw, 36px)', margin: '8px 0 0' }}>Redeem<br />Hadiah</h1>
      </div>
      {token && <button type="button" className="tvr-btn ghost" onClick={logout} data-testid="redeem-logout">Keluar</button>}
    </div>
  );

  if (!token) {
    return (
      <div className="tvr" data-testid="redeem-page"><style>{CSS}</style>
        <div className="tvr-wrap">
          {head}
          {pending && <div className="tvr-note" style={{ marginBottom: 14 }}>Masukkan PIN petugas dulu. QR paspor yang barusan discan langsung dicek setelah ini.</div>}
          {msg && <div className={msg.ok ? 'tvr-ok' : 'tvr-bad'} style={{ marginBottom: 14 }}>{msg.t}</div>}
          <form className="tvr-card" onSubmit={auth} style={{ display: 'grid', gap: 14 }} data-testid="redeem-pin">
            <label><span className="tvr-lbl">PIN petugas</span><input className="tvr-in" type="password" inputMode="numeric" autoComplete="off" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 8))} placeholder="••••" style={{ fontSize: 24, letterSpacing: '.3em', textAlign: 'center' }} required /></label>
            <button className="tvr-btn" disabled={busy === 'auth' || pin.length < 4}>{busy === 'auth' ? 'Memeriksa...' : 'Masuk'}</button>
            <div style={{ fontSize: 12, color: '#555', lineHeight: 1.5 }}>Halaman ini khusus petugas Info Booth. PIN diatur admin di Dashboard, Stamp Rally, tab Pengaturan.</div>
          </form>
        </div>
      </div>
    );
  }

  const eligible = v && !v.redeemed && v.count >= required;
  return (
    <div className="tvr" data-testid="redeem-page"><style>{CSS}</style>
      {win && <Confetti />}
      <div className="tvr-wrap">
        {head}
        {rewards.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }} data-testid="redeem-stock">
            {rewards.map((r) => <span key={r.id} className={`tvr-chip ${r.left <= 0 ? 'out' : ''}`}>{r.name}: sisa {r.left} · {r.chance}%</span>)}
          </div>
        )}
        {msg && <div className={msg.ok ? 'tvr-ok' : 'tvr-bad'} style={{ marginBottom: 14 }} data-testid="redeem-msg">{msg.t}</div>}

        {!v && !scan && (
          <div className="tvr-card" style={{ display: 'grid', gap: 14 }}>
            <button type="button" className="tvr-btn big" onClick={() => { setMsg(null); setScan(true); }} disabled={busy === 'look'} data-testid="redeem-scan">{busy === 'look' ? 'Mengecek...' : 'Scan QR paspor'}</button>
            <form onSubmit={(e) => { e.preventDefault(); lookup(manual); }} style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto', gap: 8 }}>
              <input className="tvr-in" value={manual} onChange={(e) => setManual(e.target.value.toUpperCase())} placeholder="Atau ketik kode TV-XXXXXX" autoCapitalize="characters" data-testid="redeem-manual" />
              <button className="tvr-btn ghost" style={{ padding: '0 16px' }} disabled={!manual.trim()}>Cek</button>
            </form>
            <div style={{ fontSize: 12, color: '#555', lineHeight: 1.5 }}>Minta pengunjung membuka paspor penuh mereka, lalu scan QR yang tampil. Kode TV-XXXXXX dipakai hanya kalau QR sulit discan.</div>
          </div>
        )}
        {scan && <Scanner onCode={lookup} onClose={() => setScan(false)} />}

        {v && (
          <div className="tvr-card" style={{ display: 'grid', gap: 14 }} data-testid="redeem-card">
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'baseline' }}>
                <div className="tvr-h" style={{ fontSize: 22 }}>{v.name}</div>
                <div className="tvr-h" style={{ fontSize: 22 }}>{Math.min(v.count, required)}/{required}</div>
              </div>
              <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>TV-{v.code}{v.ig ? ` · @${v.ig}` : ''}{v.phone ? ` · WA ...${String(v.phone).slice(-4)}` : ''}</div>
            </div>
            {v.redeemed && !win && <div className="tvr-bad" data-testid="redeem-already"><b>SUDAH DITUKAR.</b> Hadiah: {v.redeemed.reward_name} ({when(v.redeemed.at)}). Jangan serahkan hadiah lagi.</div>}
            {!v.redeemed && v.count < required && <div className="tvr-bad">Stamp belum lengkap ({v.count}/{required}). Pengunjung belum bisa gacha hadiah.</div>}
            {eligible && v.flagged && (
              <label className="tvr-note" style={{ display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer' }}>
                <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ marginTop: 4 }} />
                <span><b>Perlu dicek:</b> paspor ini scan beberapa booth terlalu cepat. Pastikan story IG pengunjung sesuai, lalu centang untuk lanjut.</span>
              </label>
            )}
            {(reel || win) && (
              <div className={`tvr-reel ${win ? 'tvr-win' : ''}`} style={win ? { color: '#111' } : undefined} data-testid="redeem-reel">
                <div key={reel ? reel.k : 'w'} className={`it ${win ? '' : 'spin'}`}>{win ? win.name : reel.name}</div>
              </div>
            )}
            {win ? (
              <>
                <div className="tvr-ok" data-testid="redeem-win">Serahkan <b>{win.name}</b> ke {v.name}. Status paspor sudah tercatat ditukar.</div>
                <button type="button" className="tvr-btn" onClick={next} data-testid="redeem-next">Scan pengunjung berikutnya</button>
              </>
            ) : eligible ? (
              <button type="button" className="tvr-btn big" onClick={spin} disabled={!!busy || (v.flagged && !checked)} data-testid="redeem-spin">{busy === 'spin' ? 'Memutar...' : 'Putar gacha hadiah'}</button>
            ) : (
              <button type="button" className="tvr-btn" onClick={next}>Scan paspor lain</button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
